import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import logo from "../../images/logo/logo.png";
import emailIcon from "../../images/icon/email-icon.svg";
import locationIcon from "../../images/icon/location-icon.svg";

const Footer: React.FC = () => {
  const { t } = useLanguage();

  const handleClick = () => window.scrollTo({ top: 0, behavior: "smooth" });

  const socials = [
    {
      icon: <i className="fa-brands fa-linkedin"></i>,
      name: "LinkedIn",
      url: "https://www.linkedin.com/",
    },
    {
      icon: <i className="fa-brands fa-whatsapp"></i>,
      name: "WhatsApp",
      url: `https://wa.me/${t.company.whatsapp.replace(/[^0-9]/g, "")}`,
    },
    {
      icon: <i className="fa-brands fa-github"></i>,
      name: "GitHub",
      url: "https://github.com/",
    },
    {
      icon: <i className="fa-brands fa-youtube"></i>,
      name: "YouTube",
      url: "https://youtube.com/",
    },
  ];

  return (
    <footer className="footer footer-style-one pt-70 pb-30 bg_img" style={{ backgroundColor: "#020813", borderTop: "1px solid rgba(255,255,255,0.08)" }}>
      <div className="container mxw-1650">
        <div className="row pb-50" style={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
          {/* Column 1: Company Profile & Logo */}
          <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <div className="footer-widget">
              <Link to="/" onClick={handleClick} className="d-inline-block mb-3">
                <img src={logo} alt={t.company.name} style={{ height: "55px", width: "auto" }} />
              </Link>
              <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px", lineHeight: "1.7", maxWidth: "340px" }}>
                {t.company.description}
              </p>
              <div className="footer-social-links mt-3" style={{ display: "flex", gap: "10px" }}>
                {/* {socials.map((social, idx) => (
                  <a
                    key={idx}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.name}
                    style={{
                      width: "38px",
                      height: "38px",
                      borderRadius: "50%",
                      backgroundColor: "rgba(255,255,255,0.06)",
                      border: "1px solid rgba(255,255,255,0.12)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#00FF97",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {social.icon}
                  </a>
                ))} */}
              </div>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="col-lg-2 col-md-6 mb-4 mb-lg-0">
            <div className="footer-widget">
              <h4 style={{ color: "#fff", fontSize: "18px", fontWeight: 700, marginBottom: "20px" }}>
                {t.footer.quickLinks}
              </h4>
              <ul className="list-unstyled" style={{ lineHeight: "2.2" }}>
                <li>
                  <Link to="/" onClick={handleClick} style={{ color: "rgba(255,255,255,0.7)", transition: "color 0.2s" }}>
                    {t.nav.home}
                  </Link>
                </li>
                <li>
                  <Link to="/about" onClick={handleClick} style={{ color: "rgba(255,255,255,0.7)", transition: "color 0.2s" }}>
                    {t.nav.about}
                  </Link>
                </li>
                <li>
                  <Link to="/service-details" onClick={handleClick} style={{ color: "rgba(255,255,255,0.7)", transition: "color 0.2s" }}>
                    {t.nav.services}
                  </Link>
                </li>
                <li>
                  <Link to="/project" onClick={handleClick} style={{ color: "rgba(255,255,255,0.7)", transition: "color 0.2s" }}>
                    {t.nav.projects}
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={handleClick} style={{ color: "rgba(255,255,255,0.7)", transition: "color 0.2s" }}>
                    {t.nav.contact}
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Column 3: Services */}
          <div className="col-lg-3 col-md-6 mb-4 mb-lg-0">
            <div className="footer-widget">
              <h4 style={{ color: "#fff", fontSize: "18px", fontWeight: 700, marginBottom: "20px" }}>
                {t.footer.servicesTitle}
              </h4>
              <ul className="list-unstyled" style={{ lineHeight: "2.2" }}>
                {t.services.items.map((service) => (
                  <li key={service.id}>
                    <Link
                      to={`/service-details/${service.slug}`}
                      onClick={handleClick}
                      style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px", transition: "color 0.2s" }}
                    >
                      {service.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Column 4: Contact & Office */}
          <div className="col-lg-3 col-md-6">
            <div className="footer-widget">
              <h4 style={{ color: "#fff", fontSize: "18px", fontWeight: 700, marginBottom: "20px" }}>
                {t.footer.contactTitle}
              </h4>
              <ul className="list-unstyled" style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
                <li style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                  <img src={locationIcon} alt="location" style={{ width: "20px", marginTop: "3px" }} />
                  <span style={{ color: "rgba(255,255,255,0.7)", fontSize: "13px", lineHeight: "1.5" }}>
                    {t.company.address}
                  </span>
                </li>
                <li style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <img src={emailIcon} alt="email" style={{ width: "20px" }} />
                  <a href={`mailto:${t.company.email}`} style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>
                    {t.company.email}
                  </a>
                </li>
                {/* <li style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  <img src={callIcon} alt="phone" style={{ width: "20px" }} />
                  <a href={`tel:${t.company.phone.replace(/[^0-9+]/g, "")}`} style={{ color: "rgba(255,255,255,0.7)", fontSize: "14px" }}>
                    {t.company.phone}
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="pt-30 d-flex flex-column flex-md-row justify-content-between align-items-center" style={{ fontSize: "13px", color: "rgba(255,255,255,0.5)" }}>
          <p className="mb-2 mb-md-0">
            Copyright © {2025} <Link to="/" style={{ color: "#00FF97", fontWeight: 600 }}>{t.company.name}</Link>. {t.footer.rights}
          </p>
          <div>
            <span>Enterprise AI Integration &amp; Automation Platform</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
